<template>
   <div
      class="max-w-2xl mx-auto relative"
      :class="[marginClass, { 'overflow-hidden': link }]"
      :style="{ maxWidth: maxwidth ? `${maxwidth}px` : 'auto' }"
      data-test="blogpost-img-wrapper"
   >
      <LazyLoadingImage :style="{ paddingTop: `${ratio ? ratio * 100 : 33.3}%` }" class="relative w-full">
         <img class="absolute left-1/2 top-1/2 size-full -translate-x-1/2 -translate-y-1/2" :src="src" :alt="alt" />
      </LazyLoadingImage>
      <a
         v-if="link"
         data-test="blogpost-img-link"
         :href="link"
         target="_blank"
         rel="nofollow noopener noreferrer"
         class="richtext-img-link absolute inset-1 z-10 block"
         :aria-label="alt"
      ></a>
   </div>
</template>

<script setup lang="ts">
import { computed } from "vue";
interface Props {
   src: string;
   alt?: string | null;
   maxwidth?: number | null;
   link?: string | null;
   ratio?: number | null;
   marginTop?: "none" | "small" | "medium" | "large";
   marginBottom?: "none" | "small" | "medium" | "large";
}

const props = withDefaults(defineProps<Props>(), {
   alt: "",
   link: "",
   ratio: 0.333,
   marginTop: "medium",
   marginBottom: "medium",
});

const marginClass = computed(() => {
   const topClass = getMarginClass(props.marginTop, "t");
   const bottomClass = getMarginClass(props.marginBottom, "b");
   return `${topClass} ${bottomClass}`.trim();
});

function getMarginClass(size: string, direction: "t" | "b"): string {
   switch (size) {
      case "small":
         return `m${direction}-4 sm:m${direction}-6 md:m${direction}-8 lg:m${direction}-12`;
      case "medium":
         return `m${direction}-8 sm:m${direction}-16 md:m${direction}-20 lg:m${direction}-24`;
      case "large":
         return `m${direction}-12 sm:m${direction}-20 md:m${direction}-24 lg:m${direction}-32`;
      default: // none
         return "";
   }
}
</script>
